/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { v4ContactsMePasswordPut$Json } from '../fn/contacts/v-4-contacts-me-password-put-json';
import { V4ContactsMePasswordPut$Json$Params } from '../fn/contacts/v-4-contacts-me-password-put-json';
import { v4ContactsMePasswordPut$Xml } from '../fn/contacts/v-4-contacts-me-password-put-xml';
import { V4ContactsMePasswordPut$Xml$Params } from '../fn/contacts/v-4-contacts-me-password-put-xml';

@Injectable({ providedIn: 'root' })
export class ContactsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ContactsMePasswordPut()` */
  static readonly V4ContactsMePasswordPutPath = '/v4/contacts/me/password';

  /**
   * Changes the logged in user's password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ContactsMePasswordPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ContactsMePasswordPut$Json$Response(params?: V4ContactsMePasswordPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4ContactsMePasswordPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Changes the logged in user's password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ContactsMePasswordPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ContactsMePasswordPut$Json(params?: V4ContactsMePasswordPut$Json$Params, context?: HttpContext): Observable<void> {
    return this.v4ContactsMePasswordPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /**
   * Changes the logged in user's password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ContactsMePasswordPut$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ContactsMePasswordPut$Xml$Response(params?: V4ContactsMePasswordPut$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4ContactsMePasswordPut$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Changes the logged in user's password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ContactsMePasswordPut$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ContactsMePasswordPut$Xml(params?: V4ContactsMePasswordPut$Xml$Params, context?: HttpContext): Observable<void> {
    return this.v4ContactsMePasswordPut$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
